import { Action } from "components/actions/actions";
import { Renderer } from "components/Renderer";
import { DisplayedComponent, isDataHolderComponent } from "./Component";

export function listenDataUpdateRequest(component: DisplayedComponent) {
    component.view.addEventListener("componentDataUpdateRequested", (evt: CustomEvent) => {
        const data = evt.detail;
        if (data.target === component.definition.id) {
            const r = Renderer.instance();
            if (data.options != null) {
                r.iterateToSetOptions(component, data.options);
            }
            if (data.restrictions != null) {
                r.iterateToSetRestrictions(component, data.restrictions);
            }
            r.iterateToUpdateData(component, data.data);
        }
    });
    if (isDataHolderComponent(component)) {
        component.view.addEventListener("componentActionFireRequested", (evt: CustomEvent) => {
            const data = evt.detail.data;
            const action = evt.detail.action;
            if (evt.detail.target === component.definition.id) {
                new Action(action, null).run(data, component);
            }
        });
    }
    component.view.addEventListener("componentFocusRequested", (evt: CustomEvent) => {
        const data = evt.detail.data;
        const focus = evt.detail.focus;
        if (evt.detail.target === component.definition.id) {
            Renderer.instance().iterateToSetFocus(component, focus);
        }
    });
}
